var _path, _path2, _path3, _path4, _rect, _path5, _path6, _circle, _circle2, _ellipse, _circle3, _rect2, _rect3, _path7, _path8, _path9, _path10, _rect4, _rect5, _path11, _rect6, _rect7, _rect8, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62C49 59.2386 51.2386 57 54 57H125C127.761 57 130 59.2386 130 62V117C130 119.761 127.761 122 125 122H54C51.2386 122 49 119.761 49 117V62Z",
    fill: "#3C3C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56C43 53.2386 45.2386 51 48 51H122C124.761 51 127 53.2386 127 56V67H43V56Z",
    fill: "#17E5A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73C43 70.2386 45.2386 68 48 68H122C124.761 68 127 70.2386 127 73V117H43V73Z",
    fill: "#8BF2CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 96.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 107V98L109 105L105 107H112Z",
    fill: "#17E5A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 56C44.5 54.067 46.067 52.5 48 52.5H122C123.933 52.5 125.5 54.067 125.5 56V114C125.5 115.933 123.933 117.5 122 117.5H48C46.067 117.5 44.5 115.933 44.5 114V56Z",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 114,
    r: 15,
    fill: "#8BF2CF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 114,
    r: 12,
    fill: "#17E5A0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.824,
    cy: 113.107,
    rx: 11.9085,
    ry: 12.6481,
    transform: "rotate(32.2905 119.824 113.107)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 114,
    r: 13.5,
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 96.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 96.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121 106.5V114.434C121 114.785 121.184 115.111 121.486 115.291L126 118",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 67H126",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107V98L63 105L59 107H66Z",
    fill: "#17E5A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89 107V98L86 105L82 107H89Z",
    fill: "#17E5A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 75.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 75.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89 86V77L86 84L82 86H89Z",
    fill: "#17E5A0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 75.5,
    width: 12,
    height: 12,
    rx: 1.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 44.5,
    width: 9,
    height: 13,
    rx: 3.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 44.5,
    width: 9,
    height: 13,
    rx: 3.5,
    fill: "white",
    stroke: "#4B27E0",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86V77L63 84L59 86H66Z",
    fill: "#17E5A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112 86V77L109 84L105 86H112Z",
    fill: "#17E5A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.c33ac01f.svg";
export { ForwardRef as ReactComponent };